<template>
  <!-- eslint-disable vue/require-component-is -->
  <router-link :to="{name: to}">
    <slot />
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/components/Sidebar/Link.vue